import * as Yup from 'yup';
import moment from 'moment';
import { SUBTYPE_DRIVER_LIC, SUBTYPE_ID_CARD } from 'utils/constants';

const currentYear = moment().format('YYYY');

function haveFiles(files) {
  return files && files.length > 0;
}

export default Yup.object({
  idNumber: Yup.string()
    .min(2, 'schemas:kyc.idNumber.min')
    .max(50, 'schemas:kyc.idNumber.max')
    .required('schemas:kyc.idNumber.min'),
  dayOfExpiration: Yup.number('schemas:kyc.dayOfExpiration.number')
    .typeError('schemas:kyc.dayOfExpiration.number')
    .min(1, 'schemas:kyc.dayOfExpiration.min')
    .max(31, 'schemas:kyc.dayOfExpiration.max')
    .nullable()
    .test(
      'validate-dd-id-card',
      'schemas:kyc.dayOfExpiration.date',
      function dayCheck(value) {
        const withoutExpiration = this.resolve(Yup.ref('withoutExpiration'));
        const dayOfExpiration = value;
        const monthOfExpiration = this.resolve(Yup.ref('monthOfExpiration'));
        const yearOfExpiration = this.resolve(Yup.ref('yearOfExpiration'));

        return (
          withoutExpiration ||
          (dayOfExpiration !== undefined &&
            monthOfExpiration !== undefined &&
            yearOfExpiration !== undefined)
        );
      }
    ),
  monthOfExpiration: Yup.number('schemas:kyc.monthOfExpiration.number')
    .min(1, 'schemas:kyc.monthOfExpiration.min')
    .max(12, 'schemas:kyc.monthOfExpiration.max')
    .typeError('schemas:kyc.monthOfExpiration.number')
    .nullable()
    .test(
      'validate-mm-id-card',
      'schemas:kyc.monthOfExpiration.date',
      function monthCheck(value) {
        const withoutExpiration = this.resolve(Yup.ref('withoutExpiration'));
        const dayOfExpiration = this.resolve(Yup.ref('dayOfExpiration'));
        const monthOfExpiration = value;
        const yearOfExpiration = this.resolve(Yup.ref('yearOfExpiration'));

        return (
          withoutExpiration ||
          (dayOfExpiration !== undefined &&
            monthOfExpiration !== undefined &&
            yearOfExpiration !== undefined)
        );
      }
    ),
  yearOfExpiration: Yup.number('schemas:kyc.yearOfExpiration.number')
    .typeError('schemas:kyc.yearOfExpiration.number')
    .min(parseInt(currentYear, 10), 'schemas:kyc.yearOfExpiration.min')
    .max(2100, 'schemas:kyc.yearOfExpiration.max')
    .nullable()
    .test(
      'validate-yy-id-card',
      'schemas:kyc.yearOfExpiration.date',
      function yearCheck(value) {
        const withoutExpiration = this.resolve(Yup.ref('withoutExpiration'));
        const dayOfExpiration = this.resolve(Yup.ref('dayOfExpiration'));
        const monthOfExpiration = this.resolve(Yup.ref('monthOfExpiration'));
        const yearOfExpiration = value;

        return (
          withoutExpiration ||
          (dayOfExpiration !== undefined &&
            monthOfExpiration !== undefined &&
            yearOfExpiration !== undefined)
        );
      }
    ),
  dateError: Yup.mixed().test(
    'validate-whole-date',
    'schemas:kyc.idExpiration.date',
    function checkDate() {
      const withoutExpiration = this.resolve(Yup.ref('withoutExpiration'));
      const dayOfExpiration = this.resolve(Yup.ref('dayOfExpiration'));
      const monthOfExpiration = this.resolve(Yup.ref('monthOfExpiration'));
      const yearOfExpiration = this.resolve(Yup.ref('yearOfExpiration'));

      const currentDate = moment();
      const selectedDate = moment(
        `${yearOfExpiration}-${monthOfExpiration}-${dayOfExpiration}`,
        'YYYY-MM-DD'
      );

      if (
        !withoutExpiration &&
        dayOfExpiration &&
        monthOfExpiration &&
        yearOfExpiration &&
        parseInt(currentYear, 10) <= yearOfExpiration &&
        selectedDate.diff(currentDate, 'days') < 90
      ) {
        return false;
      }
      return true;
    }
  ),
  idDocument: Yup.mixed()
    .when('typeOfDocument', {
      is: selectedDocument =>
        selectedDocument === SUBTYPE_DRIVER_LIC ||
        selectedDocument === SUBTYPE_ID_CARD,
      then: Yup.mixed().test(
        'count of files',
        'schemas:kyc.idDocument.minDrlIdc',
        val => val && val.length === 2
      ),
      otherwise: Yup.mixed().test(
        'count of files',
        'schemas:kyc.idDocument.minPass',
        val => val && val.length === 1
      )
    })
    .test('some files', 'schemas:kyc.idDocument.required', haveFiles),
  typeOfDocument: Yup.mixed().test(
    'test-selected',
    'errors:required',
    value => value !== ''
  )
});
